import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SegmentedControl } from '@/components/SegmentedControl';
import { useFormatText } from '@/hooks/useFormatText';
import usePageTitle from '@/hooks/usePageTitle';

import FAQManagement from './FAQManagement';
import PolicyManagement from './PolicyManagement';

const EditorialPage = () => {
  const { formatText } = useFormatText();
  const [searchParams, setSearchParams] = useSearchParams();
  const { setTitle, setIsBreadcrumb } = usePageTitle();

  const pageTitle = formatText('editorial.title');

  const segment = searchParams.get('tab') === 'policy' ? 'policy' : 'faq';

  const handleSegmentChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  useEffect(() => {
    document.title = pageTitle;
    setTitle(pageTitle);
    setIsBreadcrumb([]);
  }, [setTitle, setIsBreadcrumb, pageTitle]);

  return (
    <>
      <SegmentedControl
        value={segment}
        onChange={handleSegmentChange}
        variant="underline"
        options={[
          {
            value: 'faq',
            label: formatText('editorial.tabs.faq'),
            disabled: false,
          },
          {
            value: 'policy',
            label: formatText('editorial.tabs.policy'),
            disabled: false,
          },
        ]}
        className="mb-6"
      />
      {segment === 'faq' ? <FAQManagement /> : <PolicyManagement />}
    </>
  );
};

export default EditorialPage;
